<template>
  <v-dialog
    v-model="canShowDialog"
    max-width="800px"
    :transition="false"
    class="aggregator-completing-data-dialog"
    @click:outside="closeDialog"
    @keydown.esc="closeDialog"
  >
    <v-card
      class="v-card"
      style="max-height: 70vh; display: flex; flex-direction: column; max-width: 800px;"
    >
      <!--    Loader-->
      <v-overlay
        :value="showLoader"
        class="d-flex align-center justify-center"
        opacity="0.2"
        persistent
      >
        <v-progress-circular
          indeterminate
          size="60"
          color="primary"
        ></v-progress-circular>
      </v-overlay>

      <!--      Card title-->
      <v-card-title
        class="v-card-title"
      >
        {{ $t('road-maintenance/aggregator.solution_type_selection_title') }}
        <v-spacer/>

        <div
          class="x-image"
        >
          <v-img
            src="/img/icons/x-icon-image.svg"
            contain
            width="30"
            height="30"
            @click="closeDialog"
          />
        </div>
      </v-card-title>

      <!--      Card content-->
      <v-card-text
        class="v-card-text pt-2"
        style="overflow-y: auto;"
      >
        <v-row>
          <v-col
            class="block-col"
            @click="onSolutionTypeSelection(1)"
          >
            {{ $t('road-maintenance/aggregator.approval_decision') }}
          </v-col>

          <v-col
            class="block-col"
            @click="onSolutionTypeSelection(2)"
          >
            {{ $t('road-maintenance/aggregator.decision_on_refusal') }}
          </v-col>

          <v-col
            class="block-col"
            @click="onSolutionTypeSelection(3)"
          >
            {{ $t('road-maintenance/aggregator.decision_on_suspension') }}
          </v-col>
        </v-row>
      </v-card-text>
      <v-overlay
        :value="showLoader"
        class="d-flex align-center justify-center"
        opacity="0.2"
        persistent
      >
        <v-progress-circular
          indeterminate
          size="60"
          color="primary"
        ></v-progress-circular>
      </v-overlay>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ChooseSolutionTypeDialog',

  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    config: {
      type: Object,
      default: () => ({})
    }
  },

  emits: [
    'close'
  ],

  data () {
    return {
      canShowDialog: false,
      formData: {},
      showLoader: false
    }
  },

  watch: {
    showDialog: {
      immediate: true,
      handler (val) {
        this.canShowDialog = !!val
      }
    },
    'config.currentData': {
      immediate: true,
      deep: true,
      handler (val) {
      }
    }
  },

  methods: {
    closeDialog () {
      this.$emit('close')
    },

    async onSolutionTypeSelection (type) {
      try {
        const { generateDocumentCallback } = this.config || {}

        this.showLoader = true
        if (typeof generateDocumentCallback === 'function') {
          await generateDocumentCallback({
            type
          })
        }

        this.showLoader = false
      }
      catch (exception) {
        this.showLoader = false
        console.error(exception)
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep.v-dialog__content .v-dialog {
  border-radius: 16px !important;
  box-shadow: 1px 0 4px 1px #E7EAEF80;
}

.v-card-text {
  background-color: #FFFFFF;
  padding: 20px;
}

.v-card-title {
  font-family: 'Satoshi', sans-serif;
  font-weight: 500 !important;
  font-size: 24px !important;
  line-height: 32px !important;
  color: #111827 !important;
  border-bottom: 1px solid #E5E7EB;
}

.x-image:hover {
  cursor: pointer;
}

.block-col {
  width: 144px;
  padding: 24px;
  margin: 24px;
  font-family: 'Satoshi', sans-serif;
  font-weight: 400 !important;
  font-size: 24px !important;
  line-height: 32px !important;
  color: #52525B !important;
  border: 1px solid #A1A1AA;
  border-radius: 20px;
  display: flex;
  text-align: center;
  align-items: center;
}

.block-col:nth-child(2) {
  margin: 24px 0;
}

.block-col:hover {
  border: 1px solid #163D73;
  background-color: #EDF9FF;
  color: #09090B !important;
  cursor: pointer;
}
</style>
